import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=0242c2e1&scoped=true&"
import script from "./PC.vue?vue&type=script&lang=js&"
export * from "./PC.vue?vue&type=script&lang=js&"
import style0 from "./PC.vue?vue&type=style&index=0&id=0242c2e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0242c2e1",
  null
  
)

export default component.exports